export default __webpack_public_path__ + "static/principle3-b3c5760ff2c7236c6a2713d6ef3fcbbc77294d47d3797a24dc7dc243a3b3d8a3.png";